export default {
      id: "video-usage",
      viewBox: "0 0 27 27",
      url: __webpack_public_path__ + "sprite.svg#video",
      toString: function () {
        return this.url;
      }
    }